import { AGTypeError } from '@/errors';

const TIMESTAMP_FORMATTER_NON_TIMEZONE_OPTIONS = {
  datetime: {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
  },
};

const CLIENT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

const DEFAULT_TIMESTAMP_FORMATTER = {
  ...TIMESTAMP_FORMATTER_NON_TIMEZONE_OPTIONS.datetime,
  timeZone: CLIENT_TIMEZONE,
};

const defaultTimestampDatetimeFormatter = new Intl.DateTimeFormat(
  'en-AU',
  DEFAULT_TIMESTAMP_FORMATTER as Intl.DateTimeFormatOptions
);

export function formatTimestamp(
  timestamp: string | Date | undefined,
  flavour = 'datetime',
  timeZone: string | null = null
) {
  if (flavour !== 'datetime') {
    throw new AGTypeError('Only datetime flavour is currently implemented');
  }

  let dateObj;

  if (typeof timestamp === 'string') {
    dateObj = new Date(timestamp);
  } else if (timestamp instanceof Date) {
    dateObj = timestamp;
  } else {
    throw new AGTypeError('timestamp must be Date or string');
  }

  const formatter = timeZone
    ? new Intl.DateTimeFormat('en-AU', {
        ...TIMESTAMP_FORMATTER_NON_TIMEZONE_OPTIONS.datetime,
        timeZone,
      } as Intl.DateTimeFormatOptions)
    : defaultTimestampDatetimeFormatter;

  let str = formatter.format(dateObj);

  str = str.replace(/,/, '').replace(/ (am|pm)/, '$1');

  return str;
}

export const simpleHash = (strIn: string) => {
  let hash = 0;
  for (let i = 0; i < strIn.length; i++) {
    const charCode = strIn.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash = hash & hash;
  }
  return hash;
};

export const dummyLookup = async (lookupValue: string) => {
  return [{ id: simpleHash(lookupValue), label: lookupValue }];
};

const UNICODE_NULL_CHARACTER = '\u0000';
const SORT_PAD_LENGTH = 10;

export function createSortingString(
  strIn: string,
  itemId: number,
  paddingCharacters = SORT_PAD_LENGTH
) {
  return `${strIn}${UNICODE_NULL_CHARACTER}${itemId.toString().padStart(paddingCharacters, '0')}`;
}

export function uncreateSortingString(strIn: string, paddingCharacters = SORT_PAD_LENGTH) {
  if (strIn[strIn.length - paddingCharacters - 1] !== UNICODE_NULL_CHARACTER) {
    return strIn;
  }
  return strIn.slice(0, -paddingCharacters - 1);
}

export function stripUnedifyingCharacters(strInput: string) {
  return strInput.replace(/[-,.<>{}"':;!?|`@#$%^&*()-+=~//[\]\\]/g, '');
}

export function normalizePhoneForFilter(phone: string): string {
  return phone.replace(/\D/g, '');
}
